import { render, staticRenderFns } from "./ViAdmissionHome.vue?vue&type=template&id=6abc5e46&scoped=true"
import script from "./ViAdmissionHome.vue?vue&type=script&lang=js"
export * from "./ViAdmissionHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abc5e46",
  null
  
)

export default component.exports